module.exports = __webpack_public_path__ + "img/qr-code.c387d464.png";